<script lang="ts">
  import { t } from '$core/i18n';
  import { Button } from '$ui/primitives/Button';

  let { onClose }: { onClose: () => void } = $props();
</script>

<div class="modal-overlay" role="presentation" onclick={onClose} onkeydown={(e) => e.key === 'Escape' && onClose()}>
  <div class="modal-content" role="dialog" tabindex="-1" aria-modal="true" onclick={(e) => e.stopPropagation()} onkeydown={(e) => e.stopPropagation()}>
    <h2>{t('migration.title')}</h2>
    <p>Migration from guest account is currently disabled in this version.</p>
    <div class="row-actions">
      <Button variant="plain" onclick={onClose}>{t('common.close')}</Button>
    </div>
  </div>
</div>

<style>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--z-modal, 50);
  }
  .modal-content {
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    padding: var(--space-5);
    max-width: 480px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .row-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-2);
  }
</style>